import { addControls } from './controls';
export function initHighlightCommandsPlugin(editor, highlightCommands, brandVoiceOptions) {
  addControls(editor, highlightCommands, brandVoiceOptions);
}